import { useTranslation } from 'react-i18next'
import { getTranslatedLabel } from 'src/utils/locale.util'
import { CurecallTimelineLine, CurecallTimelineMedEventItem } from '@honestica/curecall-ui'
import { TTimelineMedEventElement } from './followup-timeline.type'
import { useLocale } from 'src/hooks/use-locale'

const TimelineMedEventItem = ({ timelineElement }: { timelineElement: TTimelineMedEventElement }) => {
  const { locale } = useLocale()
  const { t } = useTranslation()

  const isMendatory = timelineElement.formConfiguration.validationType === 'REQUIRED'
  const isRepeatable = timelineElement.formConfiguration.isRepeatable

  return (
    <>
      <div className="c-relative c-group c-max-w-full">
        <CurecallTimelineMedEventItem className="tw-w-60">
          {getTranslatedLabel(locale, timelineElement.medEventLabel)}
        </CurecallTimelineMedEventItem>

        <span className="c-absolute c-shadow-xl c-left-[calc(100%+10px)] c-w-80 c-top-0 c-flex-col c-z-10 c-border c-border-grey-500 c-bg-white c-hidden group-hover:c-flex c-p-3 c-rounded-md c-text-black c-text-left">
          <h3 className="c-text-sm c-font-bold c-pb-1">
            {getTranslatedLabel(locale, timelineElement.medEventLabel)}
          </h3>
          <hr className="c-mb-3 c-border-t-grey-300" />
          <ul>
            <li className="c-flex c-mb-4 c-items-center">
              {t('pages.configuration.followups.mendatory', { isMendatory })}
            </li>
            <li className="c-flex c-mb-4 c-items-center">
              {t('pages.configuration.followups.repeatable', { isRepeatable })}
            </li>
          </ul>
        </span>
      </div>
      <CurecallTimelineLine />
    </>
  )
}

export { TimelineMedEventItem }
